import {useFetchData} from 'hooks/api/useFetchData'
import {Occupation} from 'types/api/occupations/occupation'

export const useFetchOccupations = () => {
  const path = '/api/occupations'
  return useFetchData<Occupation[]>(path, [], {})
}
